module.exports = __webpack_public_path__ + "img/barra-pasto.9158986b.jpg";